<template>
  <div class="login-card__birthday step-primary step-primary--3">
    <div>
      <div class="login-card__big-icon">
        <img src="../../../images/registration/birth.png" alt="">
      </div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <date-input v-model="form.birth_date"></date-input>

          <div class="login-card__title-box">
            <h2 class="login-card__title">{{ trans.get('auth.card.birthday.header') }}</h2>
            <p class="login-card__title-desc"> {{ trans.get('auth.card.birthday.subheader') }}</p>
          </div>
          <button type="submit" class="button__auth">
            {{ trans.get('auth.card.buttons.next_step') }}
            <img src="../../../images/registration/arrow-right.svg" class="registration-button-arrow" />
          </button>
        </form>
      </validation-observer>

      <Step :step="3"></Step>

      <button type="button" class="button button__link button--back" @click="swapComponent('auth-name-card')">
        <i class="demo-icon icon-left"> </i>
        <span>{{ trans.get('auth.card.buttons.back') }} </span>
      </button>
    </div>

  </div>
</template>
<script>
import InputDate from './InputDate';
import AuthGoBackMixin from './../../../../js/front/components/Auth/AuthGoBackMixin';
import Step from './Step';

export default {
  props: ['swapComponent', 'form'],
  mixins: [AuthGoBackMixin],
  components: {
    Step,
    'date-input': InputDate,
  },
  methods: {
    onSubmit() {
      this.swapComponent('auth-location-card');
    },
    goBack() {
      this.swapComponent('auth-name-card');
    }
  },
  activated() {
    this.$emit('update:progress', 75);
  }
};
</script>
<style scoped>
</style>
